import React, { useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { Sparkles, Shield, Lock } from "lucide-react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login, isAuthenticated, error: authError } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated) {
      history.push("/dashboard");
    }
  }, [isAuthenticated, history]);

  const handleSuccess = (credentialResponse) => {
    const success = login(credentialResponse);
    if (success) {
      history.push("/dashboard");
    }
  };

  const handleError = () => {
    console.error("Login Failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-[var(--bg-primary)]">
      <div className="card w-full max-w-md p-8 animate-fade-in">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center mx-auto mb-4 shadow-lg shadow-blue-500/25">
            <Sparkles className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gradient mb-2">Lil Admin</h1>
          <p className="text-[var(--text-tertiary)]">Secure Access Portal</p>
        </div>

        {/* Security Notice */}
        <div className="flex items-start gap-4 p-4 rounded-xl bg-[var(--surface-secondary)] border border-[var(--border-primary)] mb-6">
          <div className="w-12 h-12 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center flex-shrink-0">
            <Shield className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h3 className="font-semibold text-[var(--text-primary)] mb-1">Protected Area</h3>
            <p className="text-sm text-[var(--text-tertiary)]">
              This area is restricted to authorized administrators only
            </p>
          </div>
        </div>

        {/* Login Button */}
        <div className="flex justify-center mb-6">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            useOneTap
            theme="filled_black"
            size="large"
            text="signin_with"
            shape="pill"
            width="300"
          />
        </div>

        {authError && (
          <div className="p-4 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 text-sm text-center mb-4">
            {authError}
          </div>
        )}

        {/* Footer */}
        <div className="flex items-center justify-center gap-2 text-xs text-[var(--text-muted)]">
          <Lock className="w-3 h-3" />
          <span>Secure authentication powered by Google</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
